/* import __COLOCATED_TEMPLATE__ from './reviews.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import storage from 'embercom/vendor/intercom/storage';

interface Signature {
  Args: {};
}

export default class Reviews extends Component<Signature> {
  @service declare session: Session;

  @tracked openSectionId: string | undefined;

  private get storageKey() {
    return `inbox.inbox-list.reviews-accordion-${this.session.workspace.id}`;
  }

  constructor(owner: any, args: Record<string, never>) {
    super(owner, args);
    let stored = storage.get(this.storageKey);
    this.openSectionId = stored === null || stored === true ? 'section_a' : undefined;
  }

  @action onOpenSectionChange(sectionId: string) {
    if (sectionId === 'section_a') {
      this.openSectionId = sectionId;
      storage.set(this.storageKey, true);
    } else {
      this.openSectionId = undefined;
      storage.set(this.storageKey, false);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::Folders::Default::Reviews': typeof Reviews;
    'inbox2/left-nav/folders/default/reviews': typeof Reviews;
  }
}
